<template>
  <MobileDrawer v-model:open="open">
    <template #logo>
      <AppLogo
        full
        class="h-6.5 text-primary-foreground"
      />
    </template>
    <template
      v-if="$slots.top"
      #top
    >
      <slot name="top" />
    </template>
    <slot />
    <template #footer>
      <DSSidebarItem
        label="Need Help?"
        :icon="MessageCircleQuestionIcon"
        class="h-11"
        @click="handleNeedHelp"
      />
      <slot name="footer" />
      <UserAccordion @click:item="open = false" />
    </template>
  </MobileDrawer>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'

import { useHubspot } from '@/plugins/hubspot'

import { useModalsStore } from '@/store/modals'

import HubspotUnavailableDialog from './HubspotUnavailableDialog.vue'
import MobileDrawer from './MobileDrawer.vue'

import { AppLogo } from '@app'
import { DSSidebarItem } from '@ds'
import { MessageCircleQuestion as MessageCircleQuestionIcon } from '@lucide/vue'
import UserAccordion from './UserAccordion.vue'

const open = defineModel<boolean>('open', { default: false })

const modalsStore = useModalsStore()
const hubspot = useHubspot()

const handleNeedHelp = () => {
  open.value = false
  if (hubspot?.isLoaded) {
    hubspot.open()
  } else {
    const modalInstance = modalsStore.init('hubspot-unavailable', markRaw(HubspotUnavailableDialog))
    modalInstance?.open(modalsStore.getZIndex())
  }
}
</script>
